<template>
  <div class="contract-offer-wrapper text-document">
    <img
      v-if="offerFormIsLoading"
      src="@icons/bubble-loader.svg"
      class="contract-offer-wrapper__loader"
    />
    <div v-else class="contract-offer" v-html="offerFormHTML"></div>
  </div>
</template>

<script>
import(
  /* webpackPrefetch: true */
  /* webpackChunkName: "text-document" */
  "../../assets/scss/text-document.scss"
);

import { mapGetters } from "vuex";

export default {
  name: "ContractOfferWrapper",

  computed: {
    ...mapGetters({
      offerFormHTML: "Organizations/ActiveOne/getOfferFormHTML",
      offerFormIsLoading: "Organizations/ActiveOne/isOfferFormLoading",
    }),
  },
};
</script>

<style lang="scss">
.contract-offer-wrapper {
  &__loader {
    position: relative;
    top: 200px;
    left: 50%;
    width: 24px;
  }
}

.contract-offer {
  &__head {
    display: flex;
    min-height: 122px;
    align-items: center;
    justify-content: space-between;
  }

  &__logo {
    width: 95px;
    min-width: 95px;
    height: 60px;
    min-height: 60px;
    background-image: url("@icons/offer-logo.svg");
    background-repeat: no-repeat;
    background-size: contain;
  }

  &__mark {
    color: #9c9c9c;
    font-size: 16px;
  }

  &__title {
    font-size: 20px;
    text-align: center;
  }

  &__application {
    margin-top: 30px;
  }
}

/* CALENDAR */

.calendar {
  display: flex;
  flex-wrap: wrap;
  margin-top: 50px;
}

.calendar__body {
  display: flex;
  width: 308px;
  max-width: 308px;
  box-sizing: border-box;
  flex-direction: column;
  padding: 10px;
  border: 1px solid #efefef;
  border-radius: 16px;
  margin-right: 40px;

  @media (max-width: 600px) {
    margin-right: 10px;
  }
}

.calendar__month {
  margin-bottom: 10px;
  color: #414141;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
}

.calendar__week {
  display: flex;
  width: 100%;
  align-items: center;
}

.calendar__day {
  position: relative;
  display: flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #414141;
  font-size: 16px;
}

.calendar__day--holiday {
  color: #9c9c9c;
}

.calendar__mark {
  position: absolute;
  bottom: 0;
  left: 50%;
  display: flex;
  width: 18px;
  justify-content: center;
  transform: translateX(-50%);
}

.calendar__side {
  width: 8px;
  height: 8px;
  border-radius: 8px;
}

.calendar__side--executor {
  margin-left: 1px;
}

.calendar__side--client {
  margin-right: 1px;
}

.calendar__note {
  margin-top: 32px;
}

.calendar__description {
  min-width: 320px;
  flex: 1;
}

/* NOTE */

.note {
}

.note__point {
  display: flex;
  align-items: center;
}

.note__point:not(:first-child) {
  margin-top: 2px;
}

/* CALENDAR TABLE */

.calendar-table {
}

.calendar-table__row {
}

.calendar-table__row:not(:first-child) .calendar-table__col {
  padding-top: 20px;
}

.calendar-table__col {
  color: #6b6b6b;
  font-size: 16px;
  vertical-align: baseline;
}

.calendar-table__col--date {
  color: #6a75b1;
  font-weight: 700;
  white-space: nowrap;
}

.calendar-table__col:not(:first-child) {
  padding-left: 30px;
}

.calendar-table__text {
  line-height: 25px;
}
</style>
